import { ApplicationState } from '..';

export const getUserInfos = function getUserInfos(state:ApplicationState) {
    //console.log(state);
    return state.userInfo.allIds.map(function (id:string) {
      return state.userInfo.byId[id];
    });
};

// export const getSelectedUserInfo = function getSelectedUserInfo(state:ApplicationState) {
//   return state.userInfo.byId[state.userInfo.ui.selected];
// };

export const getSelectedUserInfo = function getSelectedUserInfo(state:ApplicationState) {
  return state.userInfo;
};


export const getSelectedUserInfoById = function getSelectedUserInfoById(state:ApplicationState, id:string) {
  return state.userInfo.byId[id];
};
